import { ENDPOINTS } from "../../constant/routes";
import { request } from "../../services/requests";

export interface ListingSearchResult {
  listing_id: string;
  name: string;
  price: number;
  currency: string;
  status: string | null;
  is_one: boolean | null;
  seller_id: string;
  seller_username: string | null;
  gcs_uri: string | null;
}

export interface BuyerAddress {
  address_id: string;
  first_name: string | null;
  last_name: string | null;
  address: string;
  postal_code: string;
  country: string;
  is_primary: boolean;
}

export interface BuyerWithAddresses {
  user: { user_id: string; username: string | null; email: string };
  addresses: BuyerAddress[];
}

export interface ManualOrderPayload {
  listing_id: string;
  buyer_id: string;
  address_id: string;
  quantity: number;
  /** Create even though a recent order for this buyer and listing exists */
  allow_duplicate?: boolean;
}

export interface ManualOrderResult {
  order_id: string;
  currency: string;
  items_total: number;
  delivery_total: number;
  /** Items + delivery, in `currency` */
  total: number;
}

export const searchListings = (query: string, token: string) =>
  request(token).get<ListingSearchResult[]>(`${ENDPOINTS.LISTINGS}/search`, {
    params: { q: query },
  });

export const getUserAddresses = (userId: string, token: string) =>
  request(token).get<BuyerWithAddresses>(
    `${ENDPOINTS.USERS}/${encodeURIComponent(userId)}/addresses`
  );

export const createManualOrder = (payload: ManualOrderPayload, token: string) =>
  request(token).post<ManualOrderResult>(`${ENDPOINTS.ORDERS}/manual`, payload);
